import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { useLocale } from '@/i18n/LocaleContext';
import { SocialIconLinks } from './Social';

export const Header = () => {
  const { t } = useLocale();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { href: '#story', label: t.nav.story },
    { href: '#tokenomics', label: t.nav.tokenomics },
    { href: '#gold', label: t.nav.gold },
    { href: '#memes', label: t.nav.memes },
    { href: '#contract', label: t.nav.contract },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 border-b-2 border-primary/70 transition-colors ${
        scrolled ? 'bg-background/95 backdrop-blur-md' : 'bg-background/70 backdrop-blur-sm'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 sm:h-[72px] items-center justify-between gap-4">
          <a href="#top" data-testid="header-logo" className="flex items-center gap-3 shrink-0" aria-label={t.brand.name}>
            <img
              src="/assets/00-brand/token-logo/peipei-token-circle-512.png"
              alt={t.hero.altPortrait}
              className="h-10 w-10 sm:h-11 sm:w-11 rounded-full border-2 border-primary"
            />
            <span className="font-display font-bold text-lg sm:text-xl tracking-tight text-foreground">
              PEPE <span className="text-primary">{'\u4F69\u4F69'}</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1" aria-label="Main">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-link-${item.href.slice(1)}`}
                className="px-4 py-2 rounded-md text-sm font-medium text-muted-foreground hover:text-primary hover:bg-secondary"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <SocialIconLinks />
            <Button
              asChild
              size="sm"
              data-testid="header-cta"
              className="hidden sm:inline-flex bg-primary text-primary-foreground hover:bg-primary/90 font-semibold border-2 border-primary"
            >
              <a href="#tokenomics">{t.hero.ctaTokenomics}</a>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
